import { eventApi } from "shared/api/eventApi";

export const getEventRecordsRequest = (payload, options = {}) => {
  return eventApi.getEventRecords({ ...payload, signal: options.signal });
};
